import React, { Component } from 'react';
import { connect } from 'react-redux';
import AccountsView from './Accounts.view';

export class AccountsContainer extends Component {

  constructor(props){
    super(props);
    this.addAccount = this.addAccount.bind(this);
    this.importListings = this.importListings.bind(this);
    this.importTransactions = this.importTransactions.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'FETCH_EBAY_ACCOUNTS',
      payload: {},
    });
  }

  addAccount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'EBAY_AUTH_REDIRECT',
      payload: {},
    });

  }

  importListings(userId) {
    const { dispatch } = this.props;
    if (confirm('Importing Listings is an expensive process. Avoid doing it too often.')) {
      dispatch({
        type: 'EBAY_IMPORT_LISTINGS',
        payload: {
          userId
        },
      });
    }
  }

  importTransactions(userId) {
    const { dispatch } = this.props;
    dispatch({
      type: 'EBAY_IMPORT_TRANSACTIONS',
      payload: {
        userId
      },
    });
  }

  render() {
    return (<AccountsView
      {...this.props}
      addAccount={this.addAccount}
      importListings={this.importListings}
      importTransactions={this.importTransactions}
    />);
  }

}

function mapStateToProps(state) {
  const { accounts } = state;
  return {
    accounts: accounts.accounts,
  };
}

export default connect(mapStateToProps)(AccountsContainer);



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/Accounts/Accounts.container.js